import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([`footer`]);

export const socialNav = helpers.defineMultiStyleConfig({
  // The base styles for each part
  baseStyle: {
    socialHeading: {
      fontSize: { base: `xl`, md: `xs` },
      fontFamily: `heading`,
      color: `neutrals.white`,
      textTransform: `uppercase`
    }
  }
});
